export default __webpack_public_path__ + "static/Commercial-Trash-Compactors-d47fc0c50db8b23bedb759427357cf14.jpg";